import { watch } from 'vue';
import { useQueryClient } from '@tanstack/vue-query';
import { store } from '@/plugins/store';
import { queryKeys as AnalysisDashboardQueryKeys } from '@/plugins/store/actions/queries/analysis/dashboards';
import { queryKeys as InventoryQueryKeys } from '@/plugins/store/actions/queries/inventory';
import { queryKeys as RecordsQueryKeys } from '@/plugins/store/actions/queries/records';

const queryKeysToClear = [AnalysisDashboardQueryKeys.getDashboardRoot, RecordsQueryKeys.getRecordsRoot, InventoryQueryKeys.getInventoryRoot];

export function useClearCachesOnFormSubmission() {
    const queryClient = useQueryClient();

    watch(
        () => store.state.formRecentlySubmitted,
        (newValue) => {
            if (newValue) {
                for (const queryKey of queryKeysToClear) {
                    queryClient.invalidateQueries({ queryKey });
                }
            }
        }
    );
}
